module.exports = __webpack_public_path__ + "img/18.a3135b06.jpg";